export const ONGOING_KEY = 'Ongoing'
